<template>
    <div class="table">
        <div class="container">
            <div class="handle-box">
                <el-form :model="queryCondition" :label-position="labelPosition" label-width="100px">
                    <el-row :gutter="16" class="form-row">
                        <el-col :span="8">
                            <el-form-item label="库存节点名称">
                                <el-input class="handle-input" v-model="queryCondition.nodeName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="库存节点组">
                                <el-select v-model="queryCondition.nodeGroup" class="handle-input">
                                    <el-option key="1" label="外库" value="外库"></el-option>
                                    <el-option key="2" label="成品库" value="成品库"></el-option>
                                    <el-option key="3" label="工厂库" value="工厂库"></el-option>
                                    <el-option key="4" label="供应商" value="供应商"></el-option>
                                    <el-option key="6" label="客户" value="客户"></el-option>
                                    <el-option key="7" label="制造" value="制造"></el-option>
                                    <el-option key="8" label="维修" value="维修"></el-option>
                                    <el-option key="9" label="售后" value="售后"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="query-btn-row">
                        <el-col>
                            <el-button type="primary">搜索</el-button>
                            <el-button type="primary">重置</el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16" class="form-row">
                        <el-col :span="8">
                            <el-form-item label="库存节点编号">
                                <el-input class="handle-input" v-model="queryCondition.nodeNo" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否有效">
                                <el-select v-model="queryCondition.isEffective" class="handle-input">
                                    <el-option key="1" label="是" value="是"></el-option>
                                    <el-option key="0" label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-row class="action-btn-row">
                <el-button class="btn" type="primary" @click="addOrEditMaterial">新增</el-button>
                <el-button class="btn" type="primary" @click="downloadTemplate">下载</el-button>
            </el-row>
            <el-table :data="tableData" border highlight-current-row class="table">
                <el-table-column prop="name" label="库存节点名称">
                    <template slot-scope="scope">
                        <router-link class="a-link" replace :to="{name: 'inventory-node-edit', params:{nodeName: scope.row.nodeName}}">{{scope.row.nodeName}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="nodeNo" label="库存节点编号"></el-table-column>
                <el-table-column prop="nodeGroup" label="库存节点组"></el-table-column>
                <el-table-column prop="updateTime" label="更新日期"></el-table-column>
                <el-table-column prop="updateUser" label="更新人"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination  @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'inventory-node',
        data() {
            return {
                tableData: [{
                    nodeName: '123456',
                    nodeNo: '00000000',
                    nodeGroup: 'red',
                    updateTime: '2019-09-09',
                    updateUser: '9999'
                }],
                total: 0,
                labelPosition: 'right',
                queryCondition:{
                    nodeName: '',
                    nodeGroup: '',
                    nodeNo: '',
                    isEffective: ''
                }
            }
        },
        methods: {
            /**
             * 翻页事件
             */
            handleCurrentChange(){

            },
            /**
             * 新增库存节点
             */
            addOrEditMaterial(){
                this.$router.replace({
                    name: 'inventory-node-edit'
                });
            },
            /**
             * 下载excel
             */
            downloadTemplate(){

            }
        }
    }
</script>
<style scoped>
    .handle-input{
        width: 95%;
    }
    /*.form-row{
        text-align: right;
    }*/
    .query-btn-row{
        width:30%;
        float: right;
    }
    .action-btn-row{
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .a-link{
        text-decoration: underline;
    }
</style>